<!-- Scanner -->
<div class="row" *ngIf="scanning">
    <zxing-scanner [formats]="allowedFormats" [enable]="scanning" [(device)]="desiredDevice"
        (camerasFound)="camerasFoundHandler($event)" (scanSuccess)="scanSuccessHandler($event)"></zxing-scanner>
    <div class="col-6 text-center" *ngIf="availableDevices.length > 1">
        <button class="btn btn-success icon-btn" (click)="changeCamera()" type="button">Change Camera<span
                class="material-icons">flip_camera_ios</span></button>
    </div>
    <div class="text-center" [ngClass]="availableDevices.length > 1 ? 'col-6' : 'col-12'">
        <button (click)="scanning = false" type="button" class="btn btn-success icon-btn">Cancel<span
                class="material-icons">cancel</span></button>
    </div>
</div>
<!-- Filters Form -->
<form *ngIf="!scanning" [formGroup]="filtersForm" (ngSubmit)="submit()">
<div class="mt-5 container">
  <div class="range-container row justify-content-end align-items-end gap-4">
    <div class="col-12 col-lg-3 date-selector mb-3 input-group px-0 width-3">
      <input class="form-control datepicker" placeholder="{{'filters.date.format' | translate }}"
        name="dpFrom" (dateSelect)="onChangeRange()" formControlName="from_date" ngbDatepicker
        [readonly]="true" #dpFrom="ngbDatepicker">
      <button class="btn btn-success calendar input-group-text" (click)="dpFrom.toggle()"
        type="button">{{'filters.date.from' | translate }}</button>
    </div>
    <div class="col-12 col-lg-3 mb-3 input-group px-0 width-3">
      <input class="form-control datepicker" (dateSelect)="onChangeRange()"
        placeholder="{{'filters.date.format' | translate }}" name="dpTo" formControlName="to_date"
        ngbDatepicker [readonly]="true" #dpTo="ngbDatepicker">
      <button class="btn btn-success calendar input-group-text" (click)="dpTo.toggle()"
        type="button">{{'filters.date.to' | translate }}</button>
    </div>
    <div class="col-2 col-lg-2 mb-3 width-2">
      <select class="form-select" formControlName="signed" (change)="onChangeRange()">
        <ng-container *ngFor="let status of docStatus">
          <option [value]="status.id">{{ 'filters.document_status.'+status.name | translate }}</option>
        </ng-container>
      </select>
    </div>
  </div>
</div>

    <div class="row gap-1">
        <ng-container *ngFor="let filter of (filters || [])">
            <ng-container *ngIf="getFilterControl(filter.name) as filterControl">
            <ng-container [ngSwitch]="filter.renderizationType">
                <ng-container *ngSwitchCase="'radio'">
                    <div class="form-group filter filter-radio col-12 mb-2">
                        <span class="required-field complex text-danger"
                            *ngIf="filter.required && filterControl?.value && filterControl?.value.length === 0">*</span>
                        <app-collapsible-card [id]="filter.name" [visible]="filter.toggle"
                            [badge]="filterControl?.value ? filterControl?.value : null"
                            [loading]="loadingFilters[filter.name]"
                            [title]="('filters.list.'+filter.name | translate)+'...'"
                            [danger]="filter.required && filter?.values && !filter.toggle && filterControl?.value && filterControl?.value.length === 0"
                            (onRemove)="removeFilterSelection($event, filter.name)"
                            (onExpand)="toggleFilterCard(filter)">
                            <div class="d-flex flex-wrap p-2">
                                <ng-container [formArrayName]="filter.name"
                                    *ngFor="let d of filter?.values | paginate: { itemsPerPage: 10, id: filter.name, currentPage: complexFiltersPage[filter.name] }; let i = index ">
                                    <div class="btn-radio mr-2">
                                        <input type="checkbox" id="{{filter.name+'-'+i}}"
                                            [checked]="checkInArray(filter.name, d.description)"
                                            (change)="onSelectFilterValue(d, filter)" />
                                        <label for="{{filter.name+'-'+i}}">{{d.description}}</label>
                                    </div>
                                </ng-container>
                            </div>
                            <div *ngIf="filter.values && filter.values.length > 10" class="m-auto py-2 d-flex">
                                <pagination-controls id="{{filter.name}}" class="ms-auto"
                                    previousLabel="{{'components.pagination.previous' | translate}}"
                                    nextLabel="{{'components.pagination.next' | translate}}"
                                    (pageChange)="complexFiltersPage[filter.name] = $event">
                                </pagination-controls>
                            </div>
                        </app-collapsible-card>
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'text'">
                    <div class="form-group filter filter-text col-12 mb-2">
                        <span class="required-field text-danger"
                            *ngIf="filter.required && !filterControl?.valid">*</span>
                        <input [ngClass]="{'alert-border': formErrorsFiltersData[filter.name]}" type="text"
                            [id]="filter.name" (blur)="checkValidatorFilterData()" class="form-control"
                            [formControlName]="filter.name"
                            placeholder="{{'filters.list.'+filter.name | translate}}...">
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'number'">
                    <div class="form-group filter filter-text col-12 mb-2">
                        <span class="required-field text-danger"
                            *ngIf="filter.required && !filterControl?.valid">*</span>
                        <input [ngClass]="{'alert-border': formErrorsFiltersData[filter.name]}" type="number"
                            (blur)="checkValidatorFilterData()" class="form-control" [id]="filter.name"
                            [formControlName]="filter.name"
                            placeholder="{{'filters.list.'+filter.name | translate}}...">
                    </div>
                </ng-container>
                <ng-container *ngSwitchCase="'qr'">
                    <div class="form-group filter filter-text col-7 mb-2 align-items-center d-flex width-7 gap-1"> 
                        <div (click)="beginScan()"
                            class="pointable d-flex flex-row justify-content-between input-card p-2 card my-4 col-6 col-md-7">
                            <h6 class="m-0">{{scannedValue ? '...' + scannedValue.substr(scannedValue.length - 4) : ('filters.list.scanner' | translate)+'...'}}</h6>
                            <span class="material-icons">qr_code_scanner</span>
                        </div>
                        <button type="button" (click)="clearQr()" class="btn btn-success ml-2">{{ 'filters.list.clear_scanner' | translate }}</button>
                    </div>
                </ng-container>
            </ng-container>
            </ng-container>
        </ng-container>
    </div>

    <div class="clearfix">
        <div class="btn-container d-flex justify-content-between mt-4 gap-2">
            <button [disabled]="!filtersForm.valid" type="submit"
                class="pull-left btn btn-success icon-btn mr-2"><span>{{'filters.search' | translate }}</span>
                <span class="material-icons">search</span></button>
            <button (click)="clear()" type="button"
                class="btn btn-success icon-btn"><span>{{'filters.clear_filters' | translate }}</span>
                <span class="material-icons">filter_alt</span></button>
        </div>
    </div>
</form>